import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

//Função para armazenar os dados e manipula-los dentre as diversas páginas
export function AuthProvider({ children }) {
  const [maquinaId, setMaquinaId] = useState('');
  const [nomeList, setNomeList] = useState([]);

  return (
    <AuthContext.Provider value={{ maquinaId, setMaquinaId, nomeList, setNomeList }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
